<template>
  <div class="container">
<!--    <div class="top">
      <img src="../../assets/logo.png" alt="logo">
    </div>-->

    <div style="min-height: 88%">
      <van-tabs
          @change="handleTabChange"
          background="transparent"
          title-active-color="#6ea501"
          title-inactive-color="#FFF"
          style="margin-top: 0.1rem"
          v-model="active" swipeable scrollspy animated>
        <van-tab
            v-for="(item, index) in channelList"
            :title="item.name"
            :key="index">
          <fly-card
              :ref="'flyCard' + index"
              :isShow="active == index"
              :contentList="item.contentList"
              :pgnum="item.pgnum"
              :isHBApp="versionInfor"
              :isAndroid="isAndroid"
              :isiPad="isiPad"
              :isiPhone="isiPhone"
              :isIOS="isIOS"
              :isWeixin="isWeixin"
              :isQQ="isQQ"
              :isWeibo="isWeibo"
              :isPc="isPc"
              :isApp="isApp"
              :activeVideoUrl="activeVideoUrl"
              :activeContentID="activeContentID"
              :activeContentData="activeContentData"
              @handlerShare="handlerShare"
              @slideChange="handlerSlideChange"
              @pauseVideo="handlerPauseVideo"
              @contentListLack="handlerContentLack"/>
        </van-tab>
      </van-tabs>

      <loading-view  v-show="loading" />
    </div>

<!--    <div class="footer" v-if="!loading">-->
    <div class="footer">
      <div v-if="isApp" class="footer-btn">
        <div @click="handlerLike" class="like">
          <img v-if="activeContentHasPraised" src="../../assets/images/like1.png">
          <img v-else src="../../assets/images/like.png">
          <span>{{ activeContentPraiseNum }}</span>
        </div>
        <div>
          <img @click="handlerComment" src="../../assets/images/comment.png">
        </div>
        <div @click="handlerShare">
          <img src="../../assets/images/share.png">
        </div>

        <div @click="handlerBackToHome">
          <img src="../../assets/images/index.png">
        </div>
      </div>


      <div v-else @click="openArea" class="open-area">
        打开海拔新闻体验飞一般感觉
      </div>
    </div>

    <van-overlay :show="showShare" @click="showShare = false">
      <div style="display: flex;flex-direction: row-reverse">
        <img src="../../assets/share1.png">
      </div>
    </van-overlay>

<!--    <van-loading v-if="loading" color="#FFF" style="position: fixed;top: 50%;left: 50%;transform:translate(-50%, -50%);" type="spinner" />-->
  </div>
</template>

<script>
import FlyCard from '../../components/FlyCard'
import LoadingView from '../../components/LoadingView'

import VanTabs from 'vant/lib/tabs'
import VanTab from 'vant/lib/tab'
import VanOverlay from 'vant/lib/overlay'
// import VanLoading from 'vant/lib/loading'

import 'vant/lib/overlay/style'
import 'vant/lib/tabs/style'
import 'vant/lib/tab/style'
import 'vant/lib/loading/style'

import { channelAll, contentList } from '../../api/card'
import { contentDetails, videoDetails, statisticsPraise } from '../../api/content'
import { wxAuthPageSign } from '../../api/wx'

import dsbridge from "dsbridge";
import wx from 'weixin-js-sdk'

export default {
  name: 'Index',
  components: {
    VanOverlay,
    VanTabs,
    VanTab,
    // VanSkeleton,
    FlyCard,
    LoadingView
  },
  data() {
    return {
      active: 0,
      channelList: [],
      versionInfor: false,
      showShare: false,
      loading: false,
      token: null,
      uid: null,

      activeContentData: null,
      activeContentPraiseNum: null,
      activeContentHasPraised: 0,
      activeVideoUrl: '',
      activeContentID: null,
      activeVideoPlay: null,

      isContentLack: true,

      wxAuthSignData: null,

      praiseTimer: null, // 节流点赞定时器
      wxPraiseTimer: null, // 节流点赞定时器

      shareLink:  null, // 分享链接

      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'updateAppMessageShareData', 'updateTimelineShareData'],

      isAndroid: null,
      isiPad: null,
      isiPhone: null,
      isIOS: null,
      isWeixin: null,
      isQQ : null,
      isWeibo: null,
      isPc: null,
      isApp: null,
    };
  },
  created() {
    this.versionInfor = this.isVersionInfor()
    this.getVersionInfo()
    this.init()
  },
  watch: {
    activeContentData (val) {
      // console.log(val);
      this.activeContentID = val?.id
      this.wxInitShare(val)
      if (val.videoUrl && (val.isLinks !== 1)) {
        // console.log(val);
        this.activeVideoUrl = val.videoUrl
        this.activeVideoPlay = true
        this.$refs['flyCard' + this.active][0].handlerPlayVideo(val)
      }else {
        if (this.activeVideoPlay) {
          this.$refs['flyCard' + this.active][0].handlerPauseVideo(val)
        }
      }
    }
  },
  methods: {
    async init(){
      // this.getChannelAll()
      await this.getWxAuthSign()
      this.getChannelAll()
      this.getUserionInfo()
    },
    handleTabChange(index) {
      const activeContentData = this.channelList[index]?.contentList[0]
      this.activeContentData = activeContentData
      this.getContentDetails(activeContentData?.id)
    },
    getChannelAll() {
      // const stime = new Date().getTime()
      this.loading = true
      channelAll({columnType: 1}).then(res => {
        const { channelId, contentId } = this.$route.query
        const { data } = res
        let list = data.filter(item => ![34, 35, 31].includes(item.id))
        // if (!channelId){
        //   console.log(list[0]);
        //   contentList({channelId: list[0].id, pgnum: 1}).then(res => {
        //     console.log('--------------------------------');
        //     const { list } = res.data
        //     console.log(list);
        //     const etime = new Date().getTime()
        //     console.log(etime - stime)
        //   })
        // }

        const requestList = []
        list.map(item => {
          requestList.push(contentList({channelId: item.id, pgnum: 1}))
        })
        Promise.all(requestList).then(async resList => {
          resList.map((item, index) => {
            const itemList = item?.data
            list[index]['contentList'] = itemList
            list[index].pgnum = 1
          })
          this.loading = false
          const activeContentData = list[0]?.contentList[0]
          if (contentId && activeContentData.id != contentId) {
            this.addFirstContent(list, contentId, channelId)
          }else {
            this.channelList = list
            this.activeContentData = activeContentData
            this.getContentDetails(activeContentData?.id)
          }
        })
      })
    },
    getContentList( ) {
      // params = {channelId: 32, pgnum :1}
      // contentList(params).then(res => {
      //   const { data } = res
      // })
    },
    getUserionInfo() {
      const appStr = dsbridge.call('getSpecialTopicValue', '0')
      // 得到app给的token uid
      try {
        // appStr = JSON.parse('{}')
        // const { token, uid } = appStr
        // this.token = token || 'eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NDg1MjEwOTUsInVpZCI6IjEwMjYyMDUiLCJsb2dpbl9zdGF0dXMiOjAsImFjY291bnRfc3RhdHVzIjoyLCJleHAiOjI2NDg1MjEwOTR9.LQUETMsSzmxeWExspgl9teGiHo6DYBjkOCYPO6ZkGTA'
        // this.uid = uid || 1026205
        dsbridge.call('printLog', appStr)
        const appData = JSON.parse(appStr)
        const { token, uid } = appData
        this.token = token
        this.uid = uid
      } catch (err) {
        dsbridge.call('printLog', err)
      }
    },
    getWxAuthSign() {
      const clientUrl = location.href.split('#')[0]
      wxAuthPageSign({clientUrl}).then(({code, data}) => {
        if (code === 0) {
          this.wxAuthSignData = data
        }
      })
    },
    getContentDetails(contentId) {
      const params = { uid: this.uid, contentId }
      contentDetails(params, this.token).then(res => {
        if (res.code === 0) {
          // console.log(res.data);
          const { praiseNum, hasPraised } = res.data
          this.activeContentPraiseNum = praiseNum
          this.activeContentHasPraised = hasPraised  === 2 ? false : true // 2为点赞
        }
      })
    },

    addFirstContent(channelList, contentId, channelId = 0) {
      const active = parseFloat(channelId)
      let activeChannelItem = channelList[active]
      if (channelId == 4) {
        videoDetails({videoId: contentId}).then(({code, data}) => {
          if (code === 0) {
            data.id = contentId
            // console.log(data);
            activeChannelItem.contentList = activeChannelItem?.contentList.filter(item => item.id !== data.id)
            activeChannelItem?.contentList.unshift(data)
            // console.log(activeChannelItem.contentList)

            this.channelList = channelList
            this.active = active
            this.activeContentData = data
          }
        })
      }else {
        contentDetails({contentId}).then(({code, data}) => {
          if (code === 0) {
            data.id = contentId

            activeChannelItem.contentList = activeChannelItem?.contentList.filter(item => item.id !== data.id)
            activeChannelItem?.contentList.unshift(data)
            // this.$set(this.channelList, active, activeChannelItem)
            channelList[active] = activeChannelItem
            this.channelList = channelList
            this.active = active
            this.activeContentData = data
            this.getContentDetails(contentId)
          }
        })
      }

    },

    // 判断当前环境
    getVersionInfo() {

      this.isAndroid = /Android/i.test(navigator.userAgent)
      this.isiPad = /iPad/i.test(navigator.userAgent)
      this.isiPhone = /iPhone|iPod/i.test(navigator.userAgent)
      this.isIOS = (this.isiPad || this.isiPhone)
      this.isWeixin = /MicroMessenger/i.test(navigator.userAgent)
      this.isQQ = /QQ/i.test(navigator.userAgent)
      this.isWeibo = /weibo/i.test(navigator.userAgent)
      this.isPc = !(this.isAndroid || this.isIOS)
      this.isApp = /hbzx/i.test(navigator.userAgent)
    },

    // 判断是否海拔APP内
    isVersionInfor() {
      // 判断版本号 /hbzx-2.0.8之后的都加上
      const versionRegExp = /hbzx-\d{1,3}.\d.\d/
      const versionInfor = navigator.userAgent.match(versionRegExp) //是否在APP内
      return versionInfor ? true : false
    },

    //分享
    handlerShare() {
      // const data = Object.assign({}, this.activeContentData)
      // data.shareUrl = this.shareLink || `https://newscdn.hndnews.com/flyCard/index.html#/`
      // console.log(data);
      if (this.versionInfor) {
        const data = Object.assign({}, this.activeContentData)
        data.shareUrl = this.shareLink || `https://newscdn.hndnews.com/flyCard/index.html#/`
        data.channelId = this.active
        dsbridge.call('shareToSocialPlatformDic', JSON.stringify(data))
      }else {
        this.showShare = true
      }
    },

    //评论
    handlerComment() {
      if (!this.isLogin()) {
        console.log('跳转登录')
        return
      }
      const data = Object.assign({}, this.activeContentData)
      dsbridge.call('openNewsComments', JSON.stringify(data))
    },

    // 返回首页
    handlerBackToHome() {
      dsbridge.call('backToHome', '{"aa":"bb"}')
    },

    // 飞卡滑动
    handlerSlideChange(data) {
      // console.log(data);
      this.getContentDetails(data.id)
      this.activeContentData = data
    },
    handlerPauseVideo() {
      this.activeVideoPlay = false
    },

    // 点赞
    handlerLike() {
      // this.activeContentHasPraised
      if (!this.isLogin()) {
        console.log('跳转登录')
        return
      }
      clearTimeout(this.praiseTimer)
      this.praiseTimer = setTimeout( () => {
        const type = this.activeContentHasPraised ? 1 : 0
        if (this.activeContentHasPraised) {
          this.activeContentPraiseNum--
        }else {
          this.activeContentPraiseNum++
        }
        this.activeContentHasPraised = !this.activeContentHasPraised
        const params = {
          resource_id: this.activeContentData.id, // 资讯id
          // resource_id: 27, // 资源id
          resource_type: 0, // 0：资讯，1：视频
          praise_type: type // 点赞类型
        }
        statisticsPraise(params, this.token ).then(function (res) {
          console.log('点赞请求成功', res)
        })
      }, 200)
    },
    // 下载
    openArea() {
      if (this.isAndroid) {
        if (this.isQQ || this.isWeixin) {
          window.open('http://a.app.qq.com/o/simple.jsp?pkgname=com.hndnews.main')
        } else {
          window.open('https://newscdn.hndnews.com/apk/hb2.0.0.apk')
        }
      } else if (this.isIOS) {
        window.open('https://itunes.apple.com/us/app/hai-ba-ye-wang/id1147099465?mt=8')
      }
    },
    // 微信分享
    wxInitShare(data) {
      let {title, introduction, imgList, id } = data
      clearTimeout(this.wxPraiseTimer)
      this.wxPraiseTimer = setTimeout( () => {
        let link = `https://newscdn.hndnews.com/flyCard/index.html#/`
        if (id) {
          id = id.split('-')[0]
          link += `?contentId=${id}&channelId=${this.active}`
        }
        this.shareLink = link
        const tempParam = {
          title,
          link,
          desc: introduction || title,
          imgUrl: imgList[0]?.url,
          success:  () => {
            // 用户确认分享后执行的回调函数
          }
        }
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: this.wxAuthSignData.appId, // 必填，公众号的唯一标识
          timestamp: this.wxAuthSignData.timestamp, // 必填，生成签名的时间戳
          nonceStr: this.wxAuthSignData.nonceStr, // 必填，生成签名的随机串
          signature: this.wxAuthSignData.signature,// 必填，签名，见附录1
          jsApiList: this.jsApiList// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(() => {
          //分享到朋友圈
          wx.onMenuShareTimeline(tempParam)
          //获取“分享给朋友”按钮点击状态及自定义分享内容接口
          wx.onMenuShareAppMessage(tempParam)
          //获取“分享到QQ”按钮点击状态及自定义分享内容接口
          wx.onMenuShareQQ(tempParam)
          //获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
          wx.onMenuShareWeibo(tempParam)
          //获取“分享到QQ空间”按钮点击状态及自定义分享内容接口
          wx.onMenuShareQZone(tempParam)

          wx.updateTimelineShareData(tempParam)
          wx.updateAppMessageShareData(tempParam)
        })
      }, 500)
    },

    // 下滑不足，加载新内容
    handlerContentLack() {
      if (this.isContentLack) {
        this.isContentLack = false
        const list = this.channelList
        const channelItem = list[this.active]
        let { contentList: channelContentList } = channelItem
        channelItem.pgnum ++

        let lastItemIssueTime = 0
        channelContentList.map(item => {
          lastItemIssueTime = item.issueTimestamp > lastItemIssueTime ? item.issueTimestamp : lastItemIssueTime
        })

        contentList({channelId: channelItem.id, pgnum: channelItem.pgnum, lastItemIssueTime}).then(({code, data}) => {
          if (code === 0) {
            channelContentList = [...channelContentList, ...data]
            channelItem.contentList = channelContentList
            channelItem.contentList = channelContentList
            list[this.active] = channelItem
            this.channelList = list

            this.$refs['flyCard' + this.active][0].refreshSwiperKey()
            this.isContentLack = true
          }
        })
      }



    },

    // 判断是否登录
    isLogin() {
      let appStr = dsbridge.call('getSpecialTopicValue', '0')
      try {
        appStr = JSON.parse(appStr)
        const { token } = appStr
        if (token === '') {
          console.log('未登录，跳转登录页面')
          dsbridge.call("gotoLogin")
          return false
        }
        return true
      } catch (err) {
        console.log('未登录，跳转登录页面')
        dsbridge.call("gotoLogin")
        return false
      }
    }

  }
}
</script>

<style scoped>

* {
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  height: 100%;
  /*display: flex;*/
  display: flex;
  flex-direction: column;
  justify-content: center;

}

.top {
  display: flex;
  justify-content: center;
}

.top img {
  margin-top: 0.1rem;
  width: 50vw;
}

.footer {
  /*position: absolute;*/
  display: flex;
  justify-content: center;
  align-items: center;
  /*padding: 0 0.3rem;*/
  overflow: hidden;
  width: 100%;
  margin-top: 0.1rem;
  /*left: 0;*/
  /*bottom: 0.2rem;*/
}

.footer .open-area {
  text-align: center;
  background-color: #f64e45;
  font-size: 16px;
  color: #FFF;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.2rem;
  border-radius: 0.3rem;
}

.footer .footer-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 0.37rem;
}

.footer .footer-btn div{
  width: 0.46rem;
  height: 0.46rem;
  background-color: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
  /*overflow: hidden;*/
  border-radius: 50%;
}

.footer .footer-btn img{
  width: 0.3rem;
  height: 0.3rem;
}
.footer .footer-btn .like {
  position: relative;
}
.footer .footer-btn .like span{
  position: absolute;
  display: inline-block;
  font-size: 12px;
  padding: 0 0.08rem;
  border-radius: 0.05rem;
  /*border: 1px solid #b3b3b3;*/
  background-color: #f64e45;
  color: #FFF;
  right: -0.1rem;
  top: 0;
}
</style>
